import * as service from './services'
import to from 'await-to-js'

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  async saveAgendamento ({dispatch}, agendamento) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.save(agendamento))
    if (error) {
      dispatch('setLoading', false)
      throw error
    }
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/agendamento/index.js